<template>
  <div class="roadbook">
    <div>
        <div class="info">
            <img src="https://zimg.chinasinoair.com/a443a995f6ea15193e5429fffb2febe3?f=jpg" width="100%" class="info-img">
        </div>
    </div>

  </div>
</template>
<script>
export default {
  name: "noticeDetail",
  data() {
    return {
       roadbookInfo:undefined,
       parkingId:undefined
    };
  },
  methods: {
    //加载数据
    loadInfo: function(data) {

    }
  },
  mounted() {
  }
};
</script>
<style >
   .info{
     width: 100%;
     display: flex;
     flex-direction: column;
   }
   .info-img{
     margin: 0;
   }
   .info-content{
   }
</style>


